// ConvoCX app shell — generic stub page (CON-853).
// Renders a semantic <main> section with an <h1> heading for FR-12.5 pages
// that are wired for navigation but not yet built out (per Phase phasing).

import { Card, EmptyState, Text, VStack } from '@astryxdesign/core';

interface StubPageProps {
  title: string;
  description: string;
  note?: string;
}

export function StubPage({ title, description, note }: StubPageProps) {
  return (
    <main className="ccx-page">
      <h1 className="ccx-page__title">{title}</h1>
      <Text type="supporting" color="secondary">
        {description}
      </Text>
      <Card style={{ marginTop: 'var(--space-6)', width: '100%' }}>
        <EmptyState
          title={note ?? `${title} is coming soon`}
          description="This page is wired into the app shell and will ship in a later phase."
        />
      </Card>
      <VStack gap={2} style={{ marginTop: 'var(--space-6)', maxWidth: 640 }}>
        <Text type="supporting" color="secondary">
          Covered by PRD FR-12.5. Navigation and layout are verified here; feature depth lands with its phase.
        </Text>
      </VStack>
    </main>
  );
}